// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TheaterSettingsModal-module__modalOuter--XUhlD {
  --width: 10.5rem;
  position: absolute;
  top: 2.25rem;
  left: calc(2.25rem - var(--width));
  width: var(--width);
  padding: 0.25rem 0;
  font-size: 0.875rem;
  font-family: "Roboto Flex", sans-serif;
  border-radius: 0.5rem;
  padding: 0.5rem 0rem;
  border-radius: 0.5rem;
  background: var(--theater-settings-background-color);
  background-blend-mode: multiply;
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(40px);
  animation: TheaterSettingsModal-module__fadeIn--fEkil 0.3s ease-out;
  animation-fill-mode: forwards;
  z-index: 1;
}

@keyframes TheaterSettingsModal-module__fadeIn--fEkil {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.TheaterSettingsModal-module__modalRow--z3g7B {
  display: flex;
  justify-content: flex-start;
  gap: 0.5rem;
  align-items: center;
  padding: 0.5rem 0.75rem;
  align-self: stretch;
  color: var(--theater-settings-text-color);
  border: var(--button-border-width) solid var(--transparent);
  background: var(--theater-settings-background-color);
  width: 100%;
  transition: background-color 0.3s;
}

.TheaterSettingsModal-module__modalRow--z3g7B,
.TheaterSettingsModal-module__modalRow--z3g7B:active,
.TheaterSettingsModal-module__modalRow--z3g7B:hover,
.TheaterSettingsModal-module__modalRow--z3g7B:focus {
  margin: 0;
}

.TheaterSettingsModal-module__modalRow--z3g7B:hover {
  background: var(--theater-settings-hover-color);
}

.TheaterSettingsModal-module__icon--tSooN {
  color: var(--theater-settings-icon-color);
  width: 0.75rem;
  height: 0.75rem;
}

button.TheaterSettingsModal-module__backButton--OSjkP {
  color: var(--theater-settings-back-button-color);
}
button.TheaterSettingsModal-module__backButton--OSjkP:hover {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/TheaterModal/TheaterSettingsModal.module.css"],"names":[],"mappings":"AAAA;EACC,gBAAA;EAEA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;EACA,qBAAA;EACA,oBAAA;EAEA,qBAAA;EACA,oDAAA;EACA,+BAAA;EACA,gDAAA;EACA,2BAAA;EAEA,mEAAA;EACA,6BAAA;EACA,UAAA;AAFD;;AAKA;EACC;IACC,UAAA;EAFA;EAID;IACC,UAAA;EAFA;AACF;AAKA;EACC,aAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,yCAAA;EAEA,2DAAA;EACA,oDAAA;EAEA,WAAA;EACA,iCAAA;AAND;;AASA;;;;EAIC,SAAA;AAND;;AASA;EACC,+CAAA;AAND;;AASA;EACC,yCAAA;EACA,cAAA;EACA,eAAA;AAND;;AASA;EACC,gDAAA;AAND;AAQC;EACC,6BAAA;AANF","sourcesContent":[".modalOuter {\n\t--width: 10.5rem;\n\n\tposition: absolute;\n\ttop: 2.25rem;\n\tleft: calc(2.25rem - var(--width));\n\twidth: var(--width);\n\tpadding: 0.25rem 0;\n\tfont-size: 0.875rem;\n\tfont-family: \"Roboto Flex\", sans-serif;\n\tborder-radius: 0.5rem;\n\tpadding: 0.5rem 0rem;\n\n\tborder-radius: 0.5rem;\n\tbackground: var(--theater-settings-background-color);\n\tbackground-blend-mode: multiply;\n\tbox-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.3);\n\tbackdrop-filter: blur(40px);\n\n\tanimation: fadeIn 0.3s ease-out;\n\tanimation-fill-mode: forwards;\n\tz-index: 1;\n}\n\n@keyframes fadeIn {\n\tfrom {\n\t\topacity: 0;\n\t}\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n.modalRow {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tgap: 0.5rem;\n\talign-items: center;\n\tpadding: 0.5rem 0.75rem;\n\talign-self: stretch;\n\n\tcolor: var(--theater-settings-text-color);\n\n\tborder: var(--button-border-width) solid var(--transparent);\n\tbackground: var(--theater-settings-background-color);\n\n\twidth: 100%;\n\ttransition: background-color 0.3s;\n}\n\n.modalRow,\n.modalRow:active,\n.modalRow:hover,\n.modalRow:focus {\n\tmargin: 0;\n}\n\n.modalRow:hover {\n\tbackground: var(--theater-settings-hover-color);\n}\n\n.icon {\n\tcolor: var(--theater-settings-icon-color);\n\twidth: 0.75rem;\n\theight: 0.75rem;\n}\n\nbutton.backButton {\n\tcolor: var(--theater-settings-back-button-color);\n\n\t&:hover {\n\t\tbackground-color: transparent;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOuter": `TheaterSettingsModal-module__modalOuter--XUhlD`,
	"fadeIn": `TheaterSettingsModal-module__fadeIn--fEkil`,
	"modalRow": `TheaterSettingsModal-module__modalRow--z3g7B`,
	"icon": `TheaterSettingsModal-module__icon--tSooN`,
	"backButton": `TheaterSettingsModal-module__backButton--OSjkP`
};
export default ___CSS_LOADER_EXPORT___;
